import { message } from "antd/lib/message";

/**
 * Copies plain text to the clipboard with user feedback.
 */
export function copyTextToClipboard(text) {
  const str = text != null ? String(text).trim() : "";
  if (!str) {
    message.warning("Nothing to copy.");
    return;
  }
  const done = () => message.success("Copied to clipboard");
  if (navigator.clipboard && navigator.clipboard.writeText) {
    navigator.clipboard.writeText(str).then(done).catch(() => {
      legacyExecCopy(str, done);
    });
    return;
  }
  legacyExecCopy(str, done);
}

function legacyExecCopy(str, done) {
  try {
    const ta = document.createElement("textarea");
    ta.value = str;
    ta.style.position = "fixed";
    ta.style.opacity = "0";
    document.body.appendChild(ta);
    ta.select();
    document.execCommand("copy");
    document.body.removeChild(ta);
    done();
  } catch (e) {
    message.error("Could not copy");
  }
}
